
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire0d70"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire0d70"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("jasSx", function(module, exports) {

$parcel$export(module.exports, "ParentCategory", () => $7a8469afe192aa05$export$f84774d7760f2db1);

var $9q0SL = parcelRequire("9q0SL");

var $e7kZn = parcelRequire("e7kZn");
class $7a8469afe192aa05$export$f84774d7760f2db1 {
    constructor(){
        this.currentSelectItem = null;
        this.dialog = document.querySelector("#item-operate-dialog");
        this.selectInput = document.querySelector("#select-new-state");
        this.changeButton = document.querySelector("#change-button");
        this.removeButton = document.querySelector("#remove-button");
        this.notStartedYetCategory = new (0, $9q0SL.Category)("not-started-yet");
        this.wipCategory = new (0, $9q0SL.Category)("wip");
        this.finishCategory = new (0, $9q0SL.Category)("finish");
        this.dialog.addEventListener("close", ()=>{
            if (this.currentSelectItem === null) throw Error("[ParentCategory.constructor] this.currentSelectItem = null");
            switch(this.dialog.returnValue){
                case "not-started-yet":
                case "wip":
                case "finish":
                    this.moveItem(this.dialog.returnValue);
                    break;
                case "remove":
                    this.deleteItem();
                    break;
                default:
                    return;
            }
            this.currentSelectItem = null;
        });
        this.changeButton.addEventListener("click", (event)=>{
            event.preventDefault();
            this.dialog.close(this.selectInput.value);
        });
        this.removeButton.addEventListener("click", (event)=>{
            event.preventDefault();
            this.dialog.close("remove");
        });
    }
    appendNewTask(taskName) {
        const todoItem = new (0, $e7kZn.TodoItem)(taskName, (_event, todoItem)=>{
            this.currentSelectItem = todoItem;
            this.selectInput.value = todoItem.currentGroup;
            this.dialog.showModal();
        });
        this.notStartedYetCategory.appendTodo(todoItem);
    }
    moveItem(category) {
        if (this.currentSelectItem === null) throw Error("[ParentCategory.moveItem] this.currentSelectItem = null");
        this.deleteItemInCategory();
        switch(category){
            case "not-started-yet":
                this.notStartedYetCategory.appendTodo(this.currentSelectItem);
                break;
            case "wip":
                this.wipCategory.appendTodo(this.currentSelectItem);
                break;
            case "finish":
                this.finishCategory.appendTodo(this.currentSelectItem);
                break;
        }
        this.currentSelectItem = null;
    }
    deleteItem() {
        if (this.currentSelectItem === null) throw Error("[ParentCategory.deleteItem] this.currentSelectItem = null");
        this.currentSelectItem.remove();
        this.deleteItemInCategory();
        this.currentSelectItem = null;
    }
    deleteItemInCategory() {
        if (this.currentSelectItem === null) throw Error("[ParentCategory.deleteItemInCategory] this.currentSelectItem = null");
        switch(this.currentSelectItem.currentGroup){
            case "not-started-yet":
                this.notStartedYetCategory.deleteTodo(this.currentSelectItem.uuid);
                break;
            case "wip":
                this.wipCategory.deleteTodo(this.currentSelectItem.uuid);
                break;
            case "finish":
                this.finishCategory.deleteTodo(this.currentSelectItem.uuid);
                break;
        }
    }
}

});


parcelRequire("jasSx");

//# sourceMappingURL=index.a583d4ee.js.map
